<template>
  <UHeader>
    <template #left>
      <UContextMenu size="xs">
        <NuxtLink v-if="isDark" to="/" class="flex gap-2 items-end" aria-label="Back to home">
          <img
            ref="logo"
            src="/assets/zzz/logo-white.png"
            class="object-cover object-top"
            alt="template logo"
            width="45%"
            loading="lazy"
          />
        </NuxtLink>
         <NuxtLink v-else to="/" class="flex gap-2 items-end" aria-label="Back to home">
          <img
            ref="logo"
            src="/assets/zzz/logo-black.png"
            class="object-cover object-top"
            alt="template logo"
            width="45%"
            loading="lazy"
          />
        </NuxtLink>
      </UContextMenu>
    </template>

    <UNavigationMenu 
      :items="headerLinks" 
      variant="link"
      orientation="horizontal"
      content-orientation="vertical"
      :ui="{
        link: 'text-gray-900 dark:text-white text-lg font-bold',  // 增大导航栏字体
        linkLeadingIcon: 'hidden',
        content: 'w-80',
        childList: 'w-80',
        childLink: 'text-base font-medium',  // 设置下拉菜单链接的字体
        childLinkDescription: 'text-gray-400 text-sm',  // 增大下拉菜单描述文字
        arrow: 'text-primary',
        label: 'uppercase tracking-wider',
        item: 'px-4 py-3'  // 增加内边距使菜单项更大
      }"
      class="w-full justify-center"
    />

    <template #right>
      <!-- <UTooltip text="Search" :kbds="['meta', 'K']">
        <UContentSearchButton />
      </UTooltip> -->
      <div class="flex items-center gap-4">
        <ClientOnly>
          <LanguageSwitcher />
        </ClientOnly>
        <UColorModeButton />
      </div>

    </template>

    <template #body>
      <UContentNavigation :navigation="mobileNavigation" :default-open="defaultOpen" highlight />
    </template>
  </UHeader>
</template>

<script setup lang="ts">
import type { ContentNavigationItem } from '@nuxt/content'

const navigation = inject<Ref<ContentNavigationItem[]>>('navigation', ref([]))
const logo = useTemplateRef('logo')
const route = useRoute()
const stats = useStats()
const { copy } = useClipboard()
const { headerLinks } = useHeaderLinks()

const colorMode = useColorMode()

const isDark = computed(() => {
  
  // 尝试多种方式获取当前颜色模式
  const isDark = colorMode.value === 'dark' || 
                 colorMode.preference === 'dark' || 
                 (process.client && document.documentElement.classList.contains('dark'))
  return isDark
})

const logoSrc = computed(() => {
  
  // 尝试多种方式获取当前颜色模式
  const isDark = colorMode.value === 'dark' || 
                 colorMode.preference === 'dark' || 
                 (process.client && document.documentElement.classList.contains('dark'))
  return isDark ? '/assets/zzz/logo-white.png' : '/assets/zzz/logo-black.png'
})

// const version = computed(() => {
//   const versionMatch = stats.value?.version?.match(/\d+\.\d+/)
//   return versionMatch ? versionMatch[0] : undefined
// })

const mobileNavigation = computed<ContentNavigationItem[]>(() => {
  // Show Migration and Bridge on mobile only when user is reading them
  return [
    ...headerLinks.value.map(link => ({
      ...link,
      title: link.label,
      path: link.to,
      children: link.children?.map(child => ({
        ...child,
        title: child.label,
        path: child.to
      }))
    } as ContentNavigationItem))
  ].filter((item): item is ContentNavigationItem => Boolean(item))
})

const defaultOpen = computed(() => {
  const topLevelWithChildren = mobileNavigation.value.filter(link => link.children?.length)
  const currentPath = route.path

  return topLevelWithChildren.some(link => link.children?.some(child => currentPath.startsWith(child.path as string)))
})

</script>
